import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledPreviewTask = styled(Modal)`
  max-width: 100%;

  .ant-modal-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 0;
    .ant-modal-body {
      height: 100%;
      overflow-y: auto;

      .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
    }
  }
`;
